import { useGetUserClaimGroupAbilities } from '@rd-web-markets/market/dist/userAbilities';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom/cjs/react-router-dom.min';
export function ProtectedClaimGroupDescendantPage(_ref) {
  let {
    renderPage,
    pageName
  } = _ref;
  const {
    claim_group_id
  } = useParams();
  const {
    claimGroupId
  } = useParams();
  const claimGroupIntegerId = parseInt(claim_group_id || claimGroupId);
  const claimGroupObject = useMemo(() => {
    return {
      id: claimGroupIntegerId
    };
  }, [claimGroupIntegerId]);
  const user = useSelector(state => state.auth.user);
  const userClaimGroupAbilities = useGetUserClaimGroupAbilities({
    user,
    claimGroup: claimGroupObject
  });

  // the page specific abilities may or may not be defined for the given market
  /// if (userClaimGroupAbilities?.pages[pageName].canAccessPage || userClaimGroupAbilities?.pages[pageName] === undefined) {
  if (userClaimGroupAbilities?.pages[pageName].canAccessPage) {
    return renderPage();
  } else {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: `/${user.account_type}`
    });
  }
}